import React from 'react'
import Form from '../components/CandidateInfo/Form'
import NavBar from '../components/CandidateInfo/NavBar'
import Footer from '../components/Footer'

function CandidateInfo() {
  return (
    <div>
        <NavBar />
        <Form />
        <Footer />
    </div>
  )
}

export default CandidateInfo